import { Token, CurrencyAmount } from '@nominex/nomiswap-sdk'
import { useMemo } from 'react'

import { useSingleCallResult } from 'state/multicall/hooks'
import { useBep20 } from './useContract'

function useTokenAllowance(token?: Token, owner?: string, spender?: string): CurrencyAmount<Token> | undefined {
  const contract = useBep20(token?.address)
  const inputs = useMemo(() => [owner, spender], [owner, spender])
  const allowance = useSingleCallResult(contract, 'allowance', inputs).result

  return useMemo(
    () => (token && allowance ? CurrencyAmount.fromRawAmount(token, allowance.toString()) : undefined),
    [token, allowance],
  )
}

export default useTokenAllowance
